// extracted by mini-css-extract-plugin
export default {"LawEnforcement":"LawEnforcement_LawEnforcement__wmT47","LawIntro":"LawEnforcement_LawIntro__rcYrj"};